import Database from 'database';

export const Types = {
  GET_PERGUNTAS: 'perguntas/GET_PERGUNTAS',
  GET_PERGUNTAS_SUCCESS: 'perguntas/GET_PERGUNTAS_SUCCESS',
  GET_PERGUNTAS_FAILED: 'perguntas/GET_PERGUNTAS_FAILED',
  ADD_PERGUNTA: 'perguntas/ADD_PERGUNTA',
  ADD_PERGUNTA_SUCCESS: 'perguntas/ADD_PERGUNTA_SUCCESS',
  ADD_PERGUNTA_FAILED: 'perguntas/ADD_PERGUNTA_FAILED',
  DELETE_PERGUNTA: 'perguntas/DELETE_PERGUNTA',
  DELETE_PERGUNTA_SUCCESS: 'perguntas/DELETE_PERGUNTA_SUCCESS',
  DELETE_PERGUNTA_FAILED: 'perguntas/DELETE_PERGUNTA_FAILED',
};

/**
 * @type {{
 *  data: Pergunta[],
 *  map: {[key: string]: Pergunta},
 *  error: string | null,
 *  loading: boolean
 * }} p
 */
const initialState = {
  data: [],
  map: {},
  error: null,
  loading: false,
};

export default function perguntasReducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_PERGUNTAS:
      return { ...state, loading: true };
    case Types.GET_PERGUNTAS_SUCCESS:
      return { loading: false, ...action.payload };
    case Types.GET_PERGUNTAS_FAILED:
      return { ...state, loading: false, ...action.payload };
    default:
      return state;
  }
}

export const Creators = {
  getPerguntas: condition => async dispatch => {
    dispatch({ type: Types.GET_PERGUNTAS });
    try {
      const perguntas = await Database.perguntas
        .filter(condition || (() => false))
        .toArray() || [];
      dispatch({
        type: Types.GET_PERGUNTAS_SUCCESS,
        payload: {
          data: perguntas,
          map: perguntas.reduce((r, p) => ({
            ...r,
            [p.id]: p,
          }), {}),
        },
      });
    } catch (oof) {
      console.error(oof.message);
      dispatch({
        type: Types.GET_PERGUNTAS_FAILED,
        payload: { error: oof.message },
      });
    }
  },
};
